<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/callOldTotal' }">{{$t('zclstj')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>查看每天详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <el-table :data="list" :span-method="objectSpanMethod" border
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="dayTime" :label="$t('value2')"></el-table-column>
                        <el-table-column prop="groupName" :label="$t('groupName')"></el-table-column>
                        <el-table-column prop="overdueDay" :label="$t('overdueDay')"></el-table-column>
                        <el-table-column prop="callNum" :label="$t('zczds')"></el-table-column>
                        <el-table-column prop="recall" :label="$t('jrchds')"></el-table-column>
                        <el-table-column prop="recallRate" :label="$t('jrchl')"></el-table-column>
                        <el-table-column prop="callMoney" :label="$t('zcje')"></el-table-column>
                        <el-table-column prop="recallMoney" :label="$t('chje')"></el-table-column>
                        <el-table-column prop="recallMoneyRate" :label="$t('chjel')"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                loading: false,
                list: [],
                value1:[],
                count: 0,
                status: null,
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
        },
        methods: {
            getList() {
                this.loading = true
                _api.get(apiurl.queryDayDetail, {
                    groupId: this.$route.query.groupId,
                    nation:localStorage.getItem("nation"),
                    createTime: this.$route.query.time
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                })
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>